import { Fragment } from 'react';
import type { ReactNode } from 'react';
import { Divider, VStack } from '@cbhq/cds-web/layout';

import type { ProductAccessRowConfig } from './ProductAccessRow';
import { ProductAccessRow } from './ProductAccessRow';
import { WORKSPACE_ROLE_PRODUCT_KEY } from './productCatalog';

export type ProductAccessGroupProps = {
  rows: ProductAccessRowConfig[];
  footer?: ReactNode;
  isEditable?: boolean;
  /** IDFE-3663 (t0018_74bfb564): render a divider above the workspace role row. */
  showWorkspaceRoleDivider?: boolean;
};

export function ProductAccessGroup({
  rows,
  footer,
  isEditable = true,
  showWorkspaceRoleDivider = false,
}: ProductAccessGroupProps) {
  return (
    <VStack gap={2} width="100%">
      {rows.map((row, index) => (
        <Fragment key={row.productKey}>
          {showWorkspaceRoleDivider &&
            row.productKey === WORKSPACE_ROLE_PRODUCT_KEY &&
            index > 0 && <Divider color="bgLine" />}
          <ProductAccessRow {...row} isEditable={row.isEditable ?? isEditable} />
        </Fragment>
      ))}
      {footer}
    </VStack>
  );
}
